import { useMutation, useQueryClient } from '@tanstack/react-query';
import { bulkAddProcessesContract, BulkAddProcessesRequest } from '@bliks-io/contracts';
import { apiClient } from '../client';
import { invalidateEntity } from '../cache-invalidation';

export function useBulkAddProcesses() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: BulkAddProcessesRequest) => {
      const { data: response } = await apiClient.post(bulkAddProcessesContract.path, data);
      return response;
    },
    onSuccess: () => {
      invalidateEntity(queryClient, 'process');
    }
  });
}
